import React, { useEffect, useState } from "react";
import {
  ContactInfo,
  MedicineInfo,
  LoginInfo,
  CustomerJourney,
} from "./Utils/IvfLabelInput";
// import { RiErrorWarningLine } from "react-icons/ri";
// import Subscription from "./Subscription";
import Button from "@mui/material/Button";
// import { useGetSubscriptionsQuery } from "../../../Service/subscription";
// import {
//   useAddHospitalMutation,
//   useAddMerchantSubscriptionMutation,
//   useGetTransactionHistoryQuery,
//   useUpdateHospitalMutation,
// } from "../../../Service/hospitals";
import {
  validate,
  validateEmail,
  validatePassword,
  validatePhone,
} from "../../../utils";
import Toast from "../../../Component/DigitalMarketing/Toast";
import ImageSelectors from "../../../Component/DigitalMarketing/ImageSelectors";
import PermissionCheck from "../../../Component/PermissionCheck";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import AntSwitch from "../../../Component/DigitalMarketing/AntSwitch";
import {
  useAddMedicineMasterMutation,
  useUpdateMedicineMasterMutation,
} from "../../../Service/MedicineMaster";
import {
  useAddCustomerJourneyMasterMutation,
  useUpdateCustomerJourneyMasterMutation,
} from "../../../Service/CustomerJourneyMaster";
import { useSelector } from "react-redux";
import BackdropLoader from "../../../Component/DigitalMarketing/BackDropLoader";

function MedicineDetails(props) {
  const { branchOptions } = props;
  //   const { data: subscription } = useGetSubscriptionsQuery();
  const [selectedSub, setSelectedSub] = useState({});
  const [medicine, setMedicine] = useState(props.medicine);
  const [updated, setUpdated] = useState(props.updated);
  const [created, setCreated] = useState(props.created);
  const [hospitalImage, setMedicineImage] = useState(true);

  const [submit, setSubmit] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const account = useSelector((state: any) => state.auth);
  const { roleName } = account;

  const [addmedicine, { isLoading: addLoading }] =
    useAddCustomerJourneyMasterMutation();
  const [updateMedicine, { isLoading: updateLoading }] =
    useUpdateCustomerJourneyMasterMutation();
  const { open, message, openSnackBar, type } = useSnackbar();

  useEffect(() => {
    setMedicine(props.medicine);
    setUpdated(props.updated);
    setCreated(props.created);

    // console.log(props.medicine);
  }, [props]);

  const handleChangeInfo = (event, check = false) => {
    setSubmit(false);

    const { name, value, checked } = event.target;
    if (name === "activeStatus") {
      setMedicine((prev) => {
        return { ...prev, [name]: checked ? "1" : "0" };
      });
      // console.log(medicine);
    } else {
      setMedicine((prev) => {
        return { ...prev, [name]: value };
      });
      // console.log(medicine);
    }
    // console.log(medicine);
  };
  function openSnackBarerror(value) {
    openSnackBar(value, "error");
  }
  function isImageFile(value: any): boolean {
    return value instanceof File && value.type.startsWith("image/");
  }
  useEffect(() => {
    console.log(medicine);
  }, [handleChangeInfo]);

  const onSave = async () => {
    setSubmit(true);
    const data = {
      ...medicine,
    };
    console.log(data);
    if (validate(medicine.customerJourneyName)) {
      if (!medicine.id) {
        try {
          const payload = await addmedicine({ ...data }).unwrap();

          props.setCreated(true);

          props.setshow(false);
        } catch (error: any) {
          // console.error("rejected", error);
          openSnackBar(error?.data.error, "error");
        }
      } else {
        var { activeStatus } = data;
        // console.log(activeStatus);
        activeStatus = activeStatus != 0 ? "1" : "0";
        // Create a new object with only the desired fields
        const extractedData = { ...data, activeStatus };

        // console.log(extractedData);
        updateMedicine({
          id: medicine.id,
          ...extractedData,
        })
          .unwrap()
          .then((payload: any) => {
            if (payload?.error?.status === 400) {
              openSnackBar(payload?.error.data.message, "error");
            } else {
              props.setUpdated(true);
              props.setshow(false);
            }
          })
          .catch((err) => {
            // console.log("dsdsd", err);
            openSnackBar(err?.data.message, "error");
          });
      }
    } else {
      openSnackBar("Fill required data", "error");
    }
  };
  return (
    <>
      <BackdropLoader loader={addLoading || updateLoading} />
      <Toast open={open} type={type} message={message} />

      <li className="d-flex">
        <div>
          <h6
            style={{
              fontSize: "18px",
              fontWeight: "700",
              lineHeight: "22px",
              letterSpacing: 0,
              textAlign: "left",
            }}
          >
            {medicine.id ? "Update journey" : "Add new journey"}
          </h6>
          <p
            style={{
              fontSize: "18px",
              fontWeight: "500",
              lineHeight: "18px",
            }}
          >
            Customer Journey
          </p>
        </div>
      </li>

      {CustomerJourney.map((a, i) => {
         if (a.role && a.role !== roleName) {
          return null;
        }
        if (roleName !== "branch" && a.name === "branchId") {
          return (
            <li className="input-custom" key={i}>
              <div className="d-flex justify-content-between mt-2">
                <div>
                  <label className="det-label">Branch Name</label>
                </div>
                <div>
                  <select
                    className="input-custom"
                    name="branchId"
                    value={medicine.branchId}
                    onChange={handleChangeInfo}
                    // disabled={view}
                  >
                    <option value="">Select Branch</option>
                    {branchOptions?.data?.map((branch) => (
                      <option key={branch.id} value={branch.id}>
                        {branch.branchName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </li>
          );
        }
        return (
          <li
            className="input-custom"
            key={i}
            style={{ height: a.name == "description" ? "100px" : "" }}
          >
            <a.tag
              img={a.img}
              label={a.label}
              name={a.name}
              value={medicine[a.key]}
              handleChange={handleChangeInfo}
              validation={a.validation}
              keyName={a.key}
              submit={submit}
            />
          </li>
        );
      })}
      <li className="input-custom">
        <>
          <span className="det-label">{"Status"}</span>
          <AntSwitch
            checked={medicine.activeStatus == 1}
            onChange={(e) => handleChangeInfo(e, true)}
            name="activeStatus"
            inputProps={{ "aria-label": "ant design" }}
          />
        </>
      </li>

      {medicine.id && (
        <div className="d-flex justify-content-center">
          {props.cancel}
          <Button
            variant="contained"
            disabled={updateLoading}
            onClick={onSave}
            id="btn-save"
          >
            {updateLoading ? "Wait" : "Update"} &#x2713;
          </Button>
        </div>
      )}
      {!medicine.id && (
        <div className="d-flex justify-content-center">
          {props.cancel}
          <Button
            variant="contained"
            disabled={addLoading}
            onClick={onSave}
            id="btn-save"
          >
            {addLoading ? "Wait" : "Save"} &#x2713;
          </Button>
        </div>
      )}
    </>
  );
}

export default React.memo(MedicineDetails);
